import React, { useEffect, useState } from "react";

function EditCategoryModal({ isOpen, onClose, category, onSubmit }) {
    const [form, setForm] = useState({
        categoryID: null,
        name: "",
        description: "",
        image: null,
        imurlcurrent: null,
    });

    // όταν ανοίγει ή αλλάζει το selected category -> γέμισε φόρμα
    useEffect(() => {
        if (!isOpen) return;
        if (!category) return;

        setForm({
            categoryID: category.categoryID ?? null,
            name: category.name ?? "",
            description: category.description ?? "",
            image: null,
            imurlcurrent: category.image ?? null,
        });
    }, [category, isOpen]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(form);
        onClose();
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
            onMouseDown={(e) => {
                if (e.target === e.currentTarget) onClose();
            }}
        >
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4">
                <div className="flex justify-between items-center p-6 border-b">
                    <h2 className="text-2xl font-serif font-bold text-custom-green">
                        Edit Category
                    </h2>
                    <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <i className="fa-solid fa-times text-2xl"></i>
                    </button>
                </div>

                <div className="p-6">
                    <form className="space-y-6" onSubmit={handleSubmit}>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Category Name
                            </label>
                            <input
                                type="text"
                                value={form.name}
                                onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-green"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Description
                            </label>
                            <textarea
                                rows="3"
                                value={form.description}
                                onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))}
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-green"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Category Image
                            </label>
                            <input
                                type="file"
                                accept="image/png,image/jpeg"
                                onChange={(e) =>
                                    setForm((p) => ({ ...p, image: e.target.files?.[0] ?? null }))
                                }
                                className="w-full"
                            />
                            <p className="text-sm text-gray-400 mt-2">PNG, JPG up to 5MB</p>
                        </div>



                        <div className="flex gap-3 pt-4">
                            <button
                                type="button"
                                onClick={onClose}
                                className="flex-1 px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 font-medium"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="flex-1 px-6 py-3 bg-custom-green text-white rounded-lg hover:bg-opacity-90 font-medium"
                            >
                                Update Category
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default EditCategoryModal;
